export default __webpack_public_path__ + "static/media/9277c14c91d1aa30ad69106d17f3b50c1581617478859.1fbefda2.webp";